export function makeConnectionPointId(id) {
  return `${id}--connection-point`
}
